import bindAllOfThis from 'src/utils/BindThisHelper';
import { EndGameScene } from 'src/games/ShipPainting/scenes/EndGameScene';
import { TiledGameObject } from 'src/games/shared/phaserHelpers/HandyTypes';
import { MainScene } from './MainScene';
import TranslateApi from 'src/utils/TranslateHelper';

export class PickAFace extends Phaser.Scene {
    gameWidth: number;
    gameHeight: number;
    map: Phaser.Tilemaps.Tilemap;

    constructor() {
        super({
            key: "PickAFace"
        });
    }

    preload(): void {
        this.load.image("background", require("src/assets/qci/backgrounds/pka_background.png"));
        this.load.tilemapTiledJSON('map', require('src/assets/qci/maps/face_painting.json'));
        this.load.atlas('assets', require("/src/assets/qci/atlas/gameFacePainting.png"), require("/src/assets/qci/atlas/gameFacePainting.json"));
    }

    initialize() {
        this.gameWidth = this.textures.game.config.width as number;
        this.gameHeight = this.textures.game.config.height as number;
        this.map = this.make.tilemap({ key: 'map' });
        bindAllOfThis(this, PickAFace.prototype);
    }

    create(): void {
        this.initialize();
        let background = this.add.image(0, 0, "background").setOrigin(0).setAlpha(0.5);

        this.map.getObjectLayer('ChooseFace').objects.forEach((ob: TiledGameObject) => {
            if (ob.name === "pickAHead1") {
                var head1 = this.add.image(ob.x, ob.y, "assets", ob.name);
                head1.setOrigin(0);
                head1.setInteractive({ useHandCursor: true });
                head1.on('pointerdown', () => {
                    MainScene.FACE = 1;
                    this.endGame();
                });
            }
            else if (ob.name === "pickAHead2") {
                var head2 = this.add.image(ob.x, ob.y, "assets", ob.name);
                head2.setOrigin(0);
                head2.setInteractive({ useHandCursor: true });
                head2.on('pointerdown', () => {
                    MainScene.FACE = 2;
                    this.endGame();
                });
            }
            else if (ob.name === "pickAHead3") {
                var head3 = this.add.image(ob.x, ob.y, "assets", ob.name);
                head3.setOrigin(0);
                head3.setInteractive({ useHandCursor: true });
                head3.on('pointerdown', () => {
                    MainScene.FACE = 3;
                    this.endGame();
                });
            }
        });

        var title = this.add.text(this.gameWidth/2, 200, TranslateApi.translate("FacePainting.Phaser.pickAHead"), {
            fontFamily: "Russo One, Arial",
            fontSize: 30,
        });
        Phaser.Display.Align.In.TopCenter(title, background);
        title.y = 75;
    }

    endGame(): void {
        this.input.setDefaultCursor("default");
        this.input.removeAllListeners();
        this.scene.add("MainScene", MainScene, true);
        this.scene.remove(this);
    }

}



// WEBPACK FOOTER //
// ./src/games/FacePainting/scenes/PickAHead.ts